import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import { ISeriesDataType } from '../../../../analytics/types';
import { IClientsAnalyticsChartsProps } from '../helper/payloadsAndTypesHelper';
import useGetTopClients from '../Hooks/useGetTopClients';

const TopClientsBarChart = ({ clientsAnalyticsChartsProps }: IClientsAnalyticsChartsProps) => {
  const title = 'Current Year Top 20 Clients';
  const data = useGetTopClients(clientsAnalyticsChartsProps);
  const bucketData: ISeriesDataType[] = [];

  data?.forEach((item) => {
    bucketData.push({
      x: item.clientName,
      y: item.placements,
    });
  });

  const options: ApexOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    xaxis: {
      title: {
        text: 'Placements',
      },
    },
    yaxis: {
      title: {
        text: 'Client Names',
      },
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: title,
    },
  };
  const series = [
    {
      data: bucketData,
      name: title,
    },
  ];
  return <ReactApexChart options={options} series={series} type="bar" height="100%" width="100%" />;
};

export default TopClientsBarChart;
